<template>
  <div class='h-dialogContainer'>
    <template>
      <BaseBusiness :formParams='formParamsBase' :reMountPage='reMount' ref="base" :opCode="opCode"></BaseBusiness>
    </template>
  </div>
</template>

<script>
import BaseBusiness from '../U_BaseBusiness';
import SubscriberTool from '../../../../subscriberconfig/util/parseFormNew/tools/subscriberTool';
import commonJs from '../../common';

export default {
  name: 'AddAreaDialog',
  components: {
    BaseBusiness,
  },
  mixins: [commonJs],
  props: [
    'opCode',
    'neid'
  ],
  methods: {
    mainHandler(data = []) {
      const $this = this;
      let arrBase = null;
      const params = {
        msgid: this.msg.addUserArea,
        neid: this.neid,
        serviceType: 'microPoc'
      };
      this.$axios.post('/lte/ems/subscriber/mcs/getParamJson', params)
        .then((response) => {
          const res = response.data.resultVal;
          const sub = new SubscriberTool();
          const resultMap = sub.$devideByGroupBy(res, data);
          arrBase = resultMap.get($this.formParamsBase.modelName);
          $this.formParamsBase = arrBase;
        });
    },
    getDatas() {
      const validateReturn = this.$refs.base.validateResult();
      if (!validateReturn) {
        console.log('表单验证不通过');
        return false;
      }
      const map = this.$refs.base.getDatas();
      const returnObj = {};
      Array.from(map).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      returnObj['productType'] = '1';
      returnObj['enterpriseDomain'] = 'mcs.com';
      return returnObj;
    },
    getDatasAnotherControl() {
      const baseDatas = this.$refs.base.getDatas();
      if (baseDatas.get('grouptype') === 2 && baseDatas.get('areaFlag') === 0) {
        this.$toast('warning', this.$t('MCS.nozonegrp'))
        return false;
      }
    },
    initAnotherBusiness(res, data) {
      switch (this.opCode) {
        case '-1':
          this.initCommonBusiness(res);
          break;
        case '0':
          this.initCommonBusiness(res);
          break;
        case '1':
          // 动态组不可修改
          if (data.grouptype === 1) {
            res.forEach((item) => {
              item.readonly = true;
            });
          } else {
            this.initCommonBusiness(res);
          }
          break;
        case '2':
          this.initCommonBusiness(res);
          break;
        default:
      }
    },
    initCommonBusiness(res) {
      res.forEach((item) => {
        switch (item.name) {
          case 'grouptype':
            if (item.options !== undefined || item.options.length !== 0) {
              for (let i = 0; i < item.options.length; i++) {
                if (item.options[i].value === 1) { // 动态组
                  item.options.splice(i, 1);
                  break;
                }
              }
            }
            break;
          default:
        }
      });
    },

    reMount() {
      this.$refs.base.reMount();
    },
  },
  data() {
    return {
      grouptype: 1,
/*      tabs: {
        elements: {
          refName: 'xxxxx',
          items: [
            { header: this.$t('MCS.voiceBusiness'), contentKey: 'item1-content' },
            { header: this.$t('MCS.dataBusiness'), contentKey: 'item2-content' },
            { header: this.$t('MCS.videoBusiness'), contentKey: 'item3-content' },
          ]
        },
        styles: {
          heightMode: 'Auto'
        }
      },*/
      formParamsBase: {
        json: '',
        formId: this.opCode + 'baseBusiness',
        subObject: '',
        modelName: 'base',
      },
    };
  },
};
</script>
